import(/* webpackMode: "eager" */ "/app/frontend/app/error.tsx");
